<template>
  <v-container class="top">
    <v-layout row>
      <v-flex md10 sm12 xs12>
        <h3 class="h3-personal">Vicerrectorias</h3>
        <v-card v-for="(centro,index) in centros" :key="index">
          <v-layout row align-center>
            <v-flex md10 sm10 xs9 class="pull">
              <span class="span-personal">{{centro.ccNombre}}</span>
            </v-flex>
            <v-flex md2 sm2 xs3>
              <v-btn @click="selectCc(centro)" color="#394049" fab small>
                <v-icon class="style-icon">arrow_forward</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      centros: []
    };
  },

  created() {
   if (this.$session.getAll().userType != 'dge'){
      alert("No tienes los permisos necesarios para acceder a esta vista")
      this.$router.push({ name: "intro" });
    }
    
    axios
      .get(process.env.ROOT_API + "/centrocosto/getAllByTipo?tipo=Vicerrectoria", this.auth)
      .then(response => {
        this.centros = response.data;
        //console.log(this.centros);
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods:{
    selectCc(centro){
      this.$session.set("ccData", centro);
      this.$router.push({ name: "intro" });
    }
  }
};
</script>


<style scoped>
.v-card {
  margin-bottom: 1%;
  padding-right: 3px;
  padding-left: 7%;
  padding-top: 0.5%;
}

.style-icon {
  font-size: 36px !important;
}

.h3-personal {
  padding-bottom: 20px;
}

.top {
  margin-top: 50px;
  margin-bottom: 50px;
}

.pull {
  text-align: left;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/primeraEtapa/ListaVicerrectorias.vue